/* eslint-disable */
import React from 'react';

const NetworkStatusBanner = () => {
  return null;
};

export default NetworkStatusBanner;
